var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5002 14.8502C17.813 14.8502 19.0721 14.3287 20.0004 13.4004C20.9287 12.4721 21.4502 11.213 21.4502 9.9002C21.4502 8.58737 20.9287 7.32832 20.0004 6.40002C19.0721 5.47171 17.813 4.9502 16.5002 4.9502C15.1874 4.9502 13.9283 5.47171 13 6.40002C12.0717 7.32832 11.5502 8.58737 11.5502 9.9002C11.5502 11.213 12.0717 12.4721 13 13.4004C13.9283 14.3287 15.1874 14.8502 16.5002 14.8502ZM4.9502 29.7002C4.9502 28.1834 5.24894 26.6815 5.82939 25.2802C6.40983 23.8789 7.26059 22.6056 8.33311 21.5331C9.40563 20.4606 10.6789 19.6098 12.0802 19.0294C13.4815 18.4489 14.9834 18.1502 16.5002 18.1502C18.017 18.1502 19.5189 18.4489 20.9202 19.0294C22.3215 19.6098 23.5948 20.4606 24.6673 21.5331C25.7398 22.6056 26.5906 23.8789 27.171 25.2802C27.7514 26.6815 28.0502 28.1834 28.0502 29.7002H4.9502Z",
    fill: "#5B656F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ebed362041a2d39981633923bdc6d29c.svg";
export { ForwardRef as ReactComponent };